export default "__VITE_ASSET__C$8J4arg__"